import { Box, Checkbox, FormControlLabel, Chip, Stack } from '@mui/material';
import Typography from "@vapor/react-extended/ExtendedTypography";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";
import { Delete as DeleteIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';

export const DuplicateCard = ({ 
    duplicate, 
    idx, 
    isSelected, 
    onSelect, 
    renderDetails,
    hasSelection,
    totalDuplicates,
    fascicoli // Aggiungi fascicoli come prop
}) => {
    const willBeDeleted = hasSelection && !isSelected;
    
    return (
        <Card 
            sx={{ 
                position: 'relative',
                border: isSelected 
                    ? '3px solid #2e7d32' 
                    : willBeDeleted 
                        ? '2px solid #d32f2f' 
                        : '1px solid #ccc',
                transition: 'all 0.3s ease',                
                backgroundColor: willBeDeleted ? '#ffebee' : 'white'
            }}
        >
            <CardContent sx={{ p: 2 }}>
                <Stack direction="row" spacing={2}>
                    {/* Contenuto principale della card */}
                    <Box sx={{ flex: 1 }}>
                        {renderDetails(duplicate, fascicoli)}
                    </Box>
                    
                    {/* Colonna destra con badge, numero e checkbox */}
                    <Box 
                        sx={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minWidth: '150px',
                            borderLeft: '1px solid #e0e0e0',
                            pl: 2,
                            gap: 2
                        }}
                    >
                        {/* Badge stato */}
                        {isSelected && (
                            <Chip 
                                icon={<CheckCircleIcon />}
                                label="DA MANTENERE" 
                                color="success" 
                                size="small"
                                sx={{ fontWeight: 'bold' }}
                            />
                        )}
                        
                        {willBeDeleted && (
                            <Chip 
                                icon={<DeleteIcon />}
                                label="VERRÀ ELIMINATA" 
                                color="error" 
                                size="small"
                                sx={{ fontWeight: 'bold' }}
                            />
                        )}
                        
                        {/* Numero duplicato */}
                        <Typography 
                            variant="h6" 
                            color={isSelected ? 'success.main' : willBeDeleted ? 'error.main' : 'primary'}
                            sx={{ textAlign: 'center' }}
                        >
                            Duplicato<br />N° {idx + 1} / {totalDuplicates}
                        </Typography>
                        
                        {/* Checkbox */}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isSelected}
                                    onChange={onSelect}
                                    color={isSelected ? "success" : "primary"}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                />
                            }
                            label={
                                <Typography variant="body2" sx={{ textAlign: 'center' }}>
                                    {isSelected ? "Mantenere questa" : "Mantieni questa"}
                                </Typography>
                            }
                            labelPlacement="bottom"
                            sx={{ 
                                m: 0,
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                        />
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
};
